<h1 class="page-title">Product Purchase</h1>
<form [formGroup]="productForm" (ngSubmit)="onSubmit(productForm.value)">
  <div class="data-item">
    <div>{{product.title}}</div>
    <div class="data-item__label label">Unit Price</div>
    <div class="data-item__value">{{product.activePrice | currency: "USD": true}} 
    <span class="strikethrough-disable" *ngIf="product.activePrice !== product.inactivePrice">{{product.inactivePrice | currency: "USD": true}}</span></div>
  </div>
  <div *ngIf="hideQuantity()" class="field">
    <div class="field__label-input-wrap">
      <label for="quantity" class="label">Quantity</label>
      <input class="input input--small" [class.input--invalid]="formErrors.quantity" 
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        formControlName="quantity" id="quantity" name="quantity" type="number" max="10" maxlength="2">
    </div>
    <div *ngIf="formErrors.quantity" class="error-message field__error-message">{{formErrors.quantity}}</div>
  </div>
  <div class="field" *ngIf="isPin">
    <div>
      <p>
      <strong>Pins are personalized with initials, original credential date and the registry number for the RRT. 
        If you wish to order pin for a credentialed practitioner other than yourself, please contact 
        <a href="mailto:Service@nbrc.org">Service@nbrc.org</a>.</strong></p>
      <p><strong>
        Please allow up to six weeks to receive your personalized lapel pin.
      </strong></p>
    </div>
    <div class="field__label-input-wrap">
      <label for="initials" class="label">What initials should be on the pin?</label>
      <input class="input input--small" [class.input--invalid]="formErrors.initials" formControlName="initials" id="initials" name="initials" appUpperCase maxlength="3">
      <div *ngIf="formErrors.initials" class="error-message field__error-message">{{formErrors.initials}}</div>
    </div>
  </div>
  <div class="form-actions form-actions--multi-step">
    <input class="button form-actions__item form-actions__item--continue" type="submit" value="Continue" />
    <button (click)="onBack($event)" class="button button--secondary form-actions__item form-actions__item--back">Back</button>
  </div>
</form>